
import Vue from 'vue';

const apiUrl = 'http://digital-minds.com.ar:30001/';

export const userService = {
    login,
    logout
};

function login(username, password) {
    var challenge = {
        "usuario": {
            "login": username,
            "password": password
        }
    };

    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(challenge)
    };

    Vue.$log.debug(challenge);

    return fetch(apiUrl +'/usuarios/login', requestOptions)
        .then(handleResponse)
        .then(response => {
            // login successful if there's a jwt token in the response
            var usuario =response.Result.entity;
            if (usuario.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('user', JSON.stringify(usuario));
            }

            return usuario;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        Vue.$log.debug(data);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            
            //const error = (data && data.message) || response.statusText;

            const error = handleErrorMesage(data)
            return Promise.reject(error);
        }

        return data;
    });
}

function handleErrorMesage(response){
   
    if(response.ResponseException !== null){
     // Si el error tiene 'data' es porque tiene info de la API
     Vue.$log.error(response.ResponseException);
     return (response.ResponseException.ExceptionMessage);
    }
    else{
       // si no, logueo el error directamente
       Vue.$log.error(response);    
       return (response);
      }
  } 